import type { NewsMode, Segment, TitlesRecord } from '../types';
import { fetchLocations, fetchTopicsForLocation } from '../api/bqQueries';

const titlesCache = new Map<string, TitlesRecord[]>();
const pendingTitles = new Map<string, Promise<TitlesRecord[]>>();
const locationsCache = new Map<string, Promise<string[]>>();

const cacheKey = (location: string, segment: Segment, mode: NewsMode, week: string) =>
  `${week}-${mode}-${segment}-${location}`;

export async function fetchTitlesForLocation(
  location: string,
  segment: Segment,
  mode: NewsMode,
  week: string
): Promise<TitlesRecord[]> {
  const key = cacheKey(location, segment, mode, week);
  if (titlesCache.has(key)) return titlesCache.get(key)!;
  if (!pendingTitles.has(key)) {
    pendingTitles.set(
      key,
      fetchTopicsForLocation(
        location,
        mode === 'political' ? 'Political' : 'General',
        segment,
        week
      ).then((records) => {
        titlesCache.set(key, records);
        pendingTitles.delete(key);
        return records;
      })
    );
  }
  return pendingTitles.get(key)!;
}

export async function fetchTitlesLocations(week: string): Promise<string[]> {
  const key = `locs-${week}`;
  if (!locationsCache.has(key)) {
    locationsCache.set(
      key,
      fetchLocations(week).then((locs) => {
        const others = locs.filter((l) => l !== 'All').sort();
        return locs.includes('All') ? ['All', ...others] : others;
      })
    );
  }
  return locationsCache.get(key)!;
}
